import FolderListRightPanel from './FolderListRightPanel.component';

export default FolderListRightPanel;